import { createReducer } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';
import { StateStatus } from '@alycecom/utils';

import { checkCredentials, setIsWrongActivateEmail } from './credentials.actions';
import { ICredentialsErrors } from './credentials.types';

export interface ICredentialsState {
  status: StateStatus;
  isWrongActivateEmail: boolean;
  errors: TLegacyErrors<ICredentialsErrors>;
}

export const initialState: ICredentialsState = {
  status: StateStatus.Idle,
  isWrongActivateEmail: false,
  errors: {},
};

export const credentials = createReducer<ICredentialsState>({}, initialState);

credentials
  .on(checkCredentials.pending, state => ({
    ...state,
    status: StateStatus.Pending,
  }))
  .on(checkCredentials.fulfilled, (state, payload) => ({
    ...state,
    status: payload,
  }))
  .on(checkCredentials.rejected, (state, payload) => ({
    ...state,
    status: StateStatus.Rejected,
    errors: payload,
  }));

credentials.on(setIsWrongActivateEmail, (state, payload) => ({
  ...state,
  status: StateStatus.Rejected,
  isWrongActivateEmail: payload,
}));
